export default __webpack_public_path__ + "static/media/Hong Kong.f032f0ae.svg";